import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../main/baseQueryWithReauth';

const ADMIN_TAG = 'admin';

/**
 * Base admin API — empty shell registered in Redux store.
 * Actual endpoints are injected lazily via injectEndpoints() in admin.endpoints.ts,
 * so the full endpoint code only loads when the admin section is accessed.
 */
export const adminApi = createApi({
  reducerPath: 'admin_api',
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    `${ADMIN_TAG}_creative_help`,
    `${ADMIN_TAG}_users`,
    `${ADMIN_TAG}_organizations`,
    `${ADMIN_TAG}_events`,
    `${ADMIN_TAG}_campaigns`,
    `${ADMIN_TAG}_creatives`,
    `${ADMIN_TAG}_landings`,
    `${ADMIN_TAG}_billings`,
    `${ADMIN_TAG}_transactions`,
    `${ADMIN_TAG}_subscriptions`,
    `${ADMIN_TAG}_wire_transfers`,
    `${ADMIN_TAG}_wire_invoices`,
    `${ADMIN_TAG}_credentials`,
    `${ADMIN_TAG}_admins`,
    `${ADMIN_TAG}_activity_logs`,
    `${ADMIN_TAG}_withdrawals`,
    `${ADMIN_TAG}_invites`,
    `${ADMIN_TAG}_user_invites`,
    `${ADMIN_TAG}_segments`,
    `${ADMIN_TAG}_integration_lists`,
    `${ADMIN_TAG}_creative_templates`,
    `${ADMIN_TAG}_landing_templates`,
    `${ADMIN_TAG}_terms`,
    `${ADMIN_TAG}_mcp_tokens`,
    `${ADMIN_TAG}_benchmarks`,
    `${ADMIN_TAG}_shadow_segments`,
    `${ADMIN_TAG}_webhooks`,
    `${ADMIN_TAG}_pnl_report`,
    `${ADMIN_TAG}_agent_threads`,
    `${ADMIN_TAG}_matching`,
    `${ADMIN_TAG}_artifacts`,
    `${ADMIN_TAG}_creative_ideas`,
    `${ADMIN_TAG}_creative_idea_categories`,
    `${ADMIN_TAG}_creative_idea_groups`,
    `${ADMIN_TAG}_event_creative_ideas`,
    `${ADMIN_TAG}_filter_options`,
    `${ADMIN_TAG}_ai_files`,
    `${ADMIN_TAG}_outreach_row`,
    `${ADMIN_TAG}_outreach_detail`,
    `${ADMIN_TAG}_outreach_funnel`,
    `${ADMIN_TAG}_premade_creatives`,
    `${ADMIN_TAG}_premade_company_assets`,
    `${ADMIN_TAG}_csv_sources`,
    `${ADMIN_TAG}_padding_list`,
    `${ADMIN_TAG}_padding_contacts`,
    `${ADMIN_TAG}_mailings`,
    `${ADMIN_TAG}_mailing_recipients`,
    `${ADMIN_TAG}_mailing_waves`,
    `${ADMIN_TAG}_email_suppressions`,
  ],
  endpoints: () => ({}),
});
